import React from 'react';
import { Link } from 'react-router-dom';

import { Icon, SportFilterHeading } from 'components';
import { OverlayType } from '../../../constants';
import { getSearchString } from '../../../utils';
import useFilterBySportHeading from './useFilterBySportHeading';

import allGames from 'assets/svg/all-games.svg';
import classicAll from 'assets/svg/classicAll.svg';

const FilterBySportHeading: React.FC = () => {
    const {
        closeOverlay,
        sportId,
        allGameMsg,
        currentOverlay,
        isClassicSport,
    } = useFilterBySportHeading();

    return (
        <Link
            onClick={closeOverlay}
            to={{
                search: getSearchString({
                    sportId: undefined,
                    tournamentId: undefined,
                    tournamentIds: undefined,
                }),
            }}
        >
            <SportFilterHeading
                title={allGameMsg}
                logo={<Icon glyph={isClassicSport ? classicAll : allGames} />}
                isActive={currentOverlay === OverlayType.NONE && !sportId}
            />
        </Link>
    );
};

export default React.memo(FilterBySportHeading);
